/** @format */

import NewsletterTwentyEightContainer from "./container/NewsletterTwentyEightContainer";
export default NewsletterTwentyEightContainer;
